import React, { useEffect, useState } from 'react';
import AnimatedLoader from '../../../components/AnimatedLoader';
import useMoengage from '../../../hooks/useMoengage';
import '../../../styles/components/MyJobsList/MyJobsList.scss';

import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Icon from '@material-ui/core/Icon';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Container from '@material-ui/core/Container';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import { FormatListBulleted } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import MyMonthlyEarning from './MyMonthlyEarning';
import knowMoreBanner from '../../../assets/knowMoreBanner.png';
import MyBottomNavigation from './BottomNavigation';
import MyJobsHeader from './MyJobsHeader';
import MyJobsFooter from './MyJobsFooter';
import MyJobCard from './MyJobCard';
import RoutingService from '../../../services/RoutingService';

const PAGE_TITLE = 'Status List';
const ANALYTICS_EVENTS = {
  WATCH_VIDEO_CLICK: 'watch_video_click',
  JOB_STATUS_FAILED: 'job_status_failed',
};

function MyJobsList() {
  const [userId, setUserId] = useState('');
  const [myJobs, setMyJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('No Applied Jobs!');

  const [createMoengageUser, trackEvent] = useMoengage();

  const watchVideo = () => {
    window.open('https://uploads-a.vahan.co/XyquHz-2359-fbfatx.n3f04.mp4');
    trackEvent(ANALYTICS_EVENTS.WATCH_VIDEO_CLICK, {
      page: PAGE_TITLE,
    });
  };

  const trackJobStatusFailedEvent = () => {
    trackEvent(ANALYTICS_EVENTS.JOB_STATUS_FAILED, {
      page: PAGE_TITLE,
    });
  };

  const knowMore = () => {
    // window.open('https://uploads-a.vahan.co/XyquHz-2359-fbfatx.n3f04.mp4');
    window.open('http://shorturl.at/tAO69');
    trackEvent('know_more_click');
  };

  const getMyJobsList = async userIdParam => {
    let jobApplications = [];
    const DEFAULT_ERROR_MESSAGE = 'Service Unavailable!';
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_HOST}/job-applications/status/${userIdParam}`
      );
      if (res.status === 200) {
        const resData = await res.json();
        jobApplications = resData.jobApplicationStatusResponse;
        setMyJobs(jobApplications);
        if (resData.user) {
          console.log('User info', resData.user);
          const { name, phoneNumber, mitraBackendUserId } = resData.user;
          createMoengageUser(mitraBackendUserId, name, phoneNumber);
        }
      } else if (res.status === 400) {
        const resData = await res.json();
        setError(resData.message);
      } else {
        setError(DEFAULT_ERROR_MESSAGE);
      }
    } catch (err) {
      setError(DEFAULT_ERROR_MESSAGE);
    } finally {
      if (!Array.isArray(jobApplications) || !jobApplications.length) {
        trackJobStatusFailedEvent();
      }
    }

    setIsLoading(false);
  };

  useEffect(() => {
    const paramString = window.location.href.split('?')[1];
    const queryString = new URLSearchParams(paramString);
    let userIdParam;
    queryString.forEach((value, key) => {
      if (key === 'userId') userIdParam = value;
    });

    if (!userIdParam) {
      setIsLoading(false);
      setError('No details available');
    } else {
      setUserId(userIdParam);
      getMyJobsList(userIdParam);
      // setTimeout(() => {
      //   setMyJobs([
      //     {
      //       baseSalary: 24000,
      //       role: 'Delivery Executive',
      //       companyName: 'Swiggy',
      //       city: 'Bangalore',
      //       status: [
      //         { type: 'APPLICATION_INITIATED', status: 'success', timestamp: new Date() },
      //         { type: 'DOCUMENTS_UPLOADED', status: 'success', timestamp: new Date() },
      //         { type: 'BACKGROUND_CHECK', status: 'pending', timestamp: new Date() },
      //         { type: 'ONBOARDING_FEE', status: 'pending', timestamp: null },
      //       ],
      //       jobId: 'job1',
      //       companyLogo: null,
      //       requirements:
      //         '{"education":["9th Class or below","Class 10th pass","Class 12th pass","ITI","Diploma","Graduate"],"jobPreference":"Part time"}',
      //     },
      //     {
      //       baseSalary: 12000,
      //       role: 'Delivery Executive',
      //       companyName: 'Uber Eats',
      //       city: 'Bangalore',
      //       status: [
      //         { type: 'APPLICATION_INITIATED', status: 'success', timestamp: new Date() },
      //         { type: 'DOCUMENTS_UPLOADED', status: 'fail', timestamp: new Date() },
      //       ],
      //       jobId: 'job2',
      //       companyLogo: null,
      //       requirements: '',
      //     },
      //   ]);
      //   setIsLoading(false);
      // }, 1000);
    }
  }, []);

  return isLoading ? (
    <AnimatedLoader />
  ) : (
    <div className="my_jobs_list">
      <MyJobsHeader showAppliedJobsText={!!userId} />

      <img
        src={knowMoreBanner}
        onClick={knowMore}
        alt="logo"
        width="100%"
        style={{ marginLeft: '-1px' }}
        id="bannerFOSReferrals"
      />
      {myJobs.length > 0 &&
        myJobs.map((el, i) => {
          // eslint-disable-next-line react/no-array-index-key
          return (
            <div key={i + el.jobId}>
              <MyJobCard {...el} key={i + el.jobId} viewJob userId={userId} />
              <MyMonthlyEarning {...el} key={i + el.jobId} viewJob userId={userId} />
            </div>
          );
        })}
      {myJobs.length <= 0 && <h2>{error}</h2>}
      <MyJobsFooter watchVideo={watchVideo} />
      <MyBottomNavigation userId={userId} name="status" />
    </div>
  );
}

export default MyJobsList;
